import { Component, inject, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AraButtonComponent } from '../ara-button/ara-button.component';
import { MatIconModule } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface TableFullscreenDialogData {
	templateRef: TemplateRef<any>;
	title?: string;
}

@Component({
	selector: 'ara-table-fullscreen-dialog',
	templateUrl: './table-fullscreen-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogModule, AraButtonComponent, MatIconModule, NgTemplateOutlet, MatTooltipModule],
})
export class TableFullscreenDialogComponent {
	readonly dialogRef = inject(MatDialogRef<TableFullscreenDialogComponent>);
	readonly data = inject<TableFullscreenDialogData>(MAT_DIALOG_DATA);
}
